(()=>{
  function parseYouTubeUrl(value) {
    try {
      const url = new URL(String(value).trim());
      if (!['https:', 'http:'].includes(url.protocol) || url.username || url.password) return null;
      const host = url.hostname.toLowerCase();
      let id;
      if (host === 'youtu.be') id = url.pathname.split('/')[1];
      else if (['youtube.com', 'www.youtube.com', 'm.youtube.com', 'youtube-nocookie.com', 'www.youtube-nocookie.com'].includes(host)) {
        if (url.pathname === '/watch') id = url.searchParams.get('v');
        else if (/^\/(shorts|embed)\//.test(url.pathname)) id = url.pathname.split('/')[2];
      }
      if (!/^[A-Za-z0-9_-]{11}$/.test(id || '')) return null;
      return { id, embed: `https://www.youtube-nocookie.com/embed/${id}`, watch: `https://www.youtube.com/watch?v=${id}` };
    } catch { return null; }
  }

if(typeof module!=='undefined'&&module.exports)module.exports={parseYouTubeUrl};
if(typeof customElements==='undefined'||customElements.get('yarnroot-video'))return;
customElements.define('yarnroot-video',class extends HTMLElement{
connectedCallback(){
if(this.initialized)return;this.initialized=true;
const video=parseYouTubeUrl(this.dataset.url),player=this.querySelector('[data-player]'),poster=this.querySelector('[data-poster]'),watch=this.querySelector('[data-watch]'),error=this.querySelector('[data-error]');
if(!video){player.hidden=true;if(poster)poster.hidden=true;if(error)error.hidden=false;return;}
if(watch){watch.href=video.watch;watch.hidden=false;}
const mount=(play=false)=>{if(player.querySelector('iframe'))return;const frame=document.createElement('iframe');frame.src=video.embed+(play?'?autoplay=1':'');frame.title=this.dataset.title||'YouTube video';frame.allow='autoplay; encrypted-media; picture-in-picture; fullscreen';frame.allowFullscreen=true;frame.referrerPolicy='strict-origin-when-cross-origin';frame.loading='lazy';player.append(frame);if(poster)poster.hidden=true;};
if(poster)poster.addEventListener('click',()=>mount(true),{once:true});else mount();
}
});})();
